export type PlanId = 'starter' | 'plus' | 'depth';

export type QuestionPlan = Readonly<{
  id: PlanId;
  name: string;
  questions: number;
  priceCents: number;
  currency: 'USD';
  summary: string;
  featured?: boolean;
}>;

export const QUESTION_PLANS: readonly QuestionPlan[] = Object.freeze([
  {
    id: 'starter',
    name: 'Starter',
    questions: 10,
    priceCents: 999,
    currency: 'USD',
    summary: 'For one focused topic or a short decision session.',
  },
  {
    id: 'plus',
    name: 'Plus',
    questions: 35,
    priceCents: 2999,
    currency: 'USD',
    summary: 'For an ongoing project, transition or deeper reflection.',
    featured: true,
  },
  {
    id: 'depth',
    name: 'Depth',
    questions: 60,
    priceCents: 4999,
    currency: 'USD',
    summary: 'For regular use across several complex decisions.',
  },
]);

export function getQuestionPlan(planId: string | null | undefined): QuestionPlan | null {
  return QUESTION_PLANS.find((plan) => plan.id === planId) ?? null;
}

export function formatPlanPrice(plan: QuestionPlan): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: plan.currency,
    minimumFractionDigits: 2,
  }).format(plan.priceCents / 100);
}
